import { isPossiblePhoneNumber } from 'react-phone-number-input';

import * as yup from 'yup';

export const phoneNumberSchema = yup
  .string()
  .trim()
  .test({
    name: 'isPossiblePhoneNumber',
    test: (value?: string | null) => value == null || isPossiblePhoneNumber(value),
  });
